import type {ReportFieldSet} from '@cypro/engine/reports'
import * as z from 'zod'

export const ReportsTabSchema = z.enum(['prescriptions', 'stockMovements'])
export type ReportsTab = z.infer<typeof ReportsTabSchema>

export const ReportsSortSchema = z.object({
  field: z.string(),
  dir: z.enum(['asc', 'desc']),
})
export type ReportsSort = z.infer<typeof ReportsSortSchema>

export const ReportsSearchSchema = z.object({
  tab: ReportsTabSchema.optional().default('prescriptions'),
  sort: ReportsSortSchema.optional(),
  /** the open shared view's id; absent means the tab's default view (CY-85) */
  view: z.string().optional(),
})

export const DEFAULT_REPORTS_SORT: ReportsSort = {field: 'therapyDate', dir: 'desc'}

/**
 * The sort is shared between the two report tabs, so a sort key that belongs to the other tab
 * (e.g. a prescriptions field while the movements tab is open) falls back to the tab's default.
 */
export function resolveReportsSort(
  sort: ReportsSort | undefined,
  fieldSet: ReportFieldSet,
  fallback: ReportsSort
): ReportsSort {
  if (!sort) return fallback
  return fieldSet.fields.some(field => field.sortKey === sort.field) ? sort : fallback
}
